<template>
    <div style="border: 1px solid #ccc;">
        <Toolbar style="border-bottom: 1px solid #ccc" :editor="editor" :defaultConfig="toolbarConfig" :mode="mode" />
        <Editor style="height: 300px; overflow-y: hidden;" v-model="html" :defaultConfig="editorConfig" :mode="mode"
            @onCreated="onCreated" @onChange="onChange" />
    </div>
</template>

<script>
import axios from "@/util/request";
import '@wangeditor/editor/dist/css/style.css'
import Vue from 'vue'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'

export default Vue.extend({
    props: {
        richContent: {
            type: String,
            default: "",
        },
    },
    components: { Editor, Toolbar },
    data() {
        return {
            editor: null,
            html: '',
            toolbarConfig: {},
            editorConfig: {
                placeholder: '请输入内容...',
                MENU_CONF: {
                    // 配置上传图片
                    uploadImage: {
                        customUpload: this.updatePicture
                    }
                }
            },
            mode: 'default', // or 'simple'
        }
    },
    methods: {
        onCreated(editor) {
            this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
        },

        onChange(editor) {
            setTimeout(() => {
                this.$emit("getRichContent", editor.getHtml());
            }, 500)
        },

        updatePicture(file, insertFn) {
            let fd = new FormData();
            fd.append("file", file);
            axios({
                method: "post",
                url: "/com/file/fileUpload", // 上传至后台服务器的接口
                data: fd,
            }).then((res) => {
                if (res) {
                    if (res.data && res.data.length > 0) {
                        res.data.forEach((item) => {
                            insertFn("https://api.gaokaozixun.com/xudejiaoyu_api/com/file/fileDownLoad?filePath=" + item.filePath, "", "")
                        });
                    }
                } else {
                    // 提示信息
                    this.$message.error("图片插入失败");
                }
            });
        }
    },
    mounted() {
        // 模拟 ajax 请求，异步渲染编辑器
        setTimeout(() => {
            this.html = this.richContent
        }, 500)
    },
    beforeDestroy() {
        const editor = this.editor
        if (editor == null) return
        editor.destroy() // 组件销毁时，及时销毁编辑器
    }
})
</script>